module.exports = __webpack_public_path__ + "img/lowwaterpressure.cf583601.svg";